module.exports = __webpack_public_path__ + "static/media/galaxy.d97e2316.png";